import axiosInstance from "./axiosInstance";
import { variables } from "./variables"



const API_URL = variables.MAINTENANCE_API;

export const fetchMaintenance = async () => {
    const response = await axiosInstance.get(API_URL);
    return response.data;
}